import { v4 as uuid } from "uuid";

const getUniqueDeviceId = () => {
  let deviceId = localStorage.getItem("deviceId");

  if (!deviceId) {
    deviceId = uuid();
    localStorage.setItem("deviceId", deviceId);
  }

  return deviceId;
};

export function cleanObject(obj) {
  const cleanedObj = { ...obj };
  for (let key in cleanedObj) {
    if (
      cleanedObj[key] === "" ||
      cleanedObj[key] === " " ||
      (Array.isArray(cleanedObj[key]) && cleanedObj[key].length === 0) ||
      /^\s+$/.test(cleanedObj[key])
    ) {
      delete cleanedObj[key];
    }
  }
  return cleanedObj;
  // const cleanedPayload = cleanObject(complainPayload);
}

export default {
  getUniqueDeviceId,
};
